import { css } from 'lit';

export default css`
    ki-ds-pwa-graph-wrapper {
        display: block;
        height: 100%;
        background-color: var(--color-surface-primary);
        border-radius: var(--metrics-radius-s);
    }
`;
